import { all } from 'redux-saga/effects'

import { appSagas } from './app';
import { orderListSagas } from './orders-lists';
import { locationsListSagas } from './locations-lists';
import { provincesListSagas } from './provinces-lists';
import { specialtiesListSagas } from './specialties-lists';
import { providerSagas } from './providers';
import { efectorlistSagas } from './efector-lists';
import { efectorSagas } from './efectores';
import { efectoresImportLogSagas } from './efectores-import-log';
import { practiceListSagas } from './practice-lists';
import { practiceEfectoresSagas } from './practice-efectores';
import { practiceEfectorVisitsSagas } from './practice-efector-visits';
import { locationsSagas } from './locations';
import { addressSagas } from './address';
import { notificationSagas } from './notifications';
import { notificationListSagas } from './notifications-lists';

export default function* sagas() {
  yield all([
    ...appSagas,
    ...orderListSagas,
    ...locationsListSagas,
    ...specialtiesListSagas,
    ...providerSagas,
    ...efectorlistSagas,
    ...efectorSagas,
    ...efectoresImportLogSagas,
    ...practiceListSagas,
    ...practiceEfectoresSagas,
    ...provincesListSagas,
    ...locationsSagas,
    ...practiceEfectorVisitsSagas,
    ...addressSagas,
    ...notificationSagas,
    ...notificationListSagas,
  ]);
}
